import { render } from "./DownloadMenu.vue?vue&type=template&id=64f76e83&scoped=true"
import script from "./DownloadMenu.vue?vue&type=script&lang=js"
export * from "./DownloadMenu.vue?vue&type=script&lang=js"

import "./DownloadMenu.vue?vue&type=style&index=0&id=64f76e83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f76e83"]])

export default __exports__